// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  cryptoAES: "xyXTvZQTcQRt5AN",
  api: "https://api.tavuel.com/dev", //"http://localhost:5000", //
  firebase: {
    apiKey: "AIzaSyCBVV-BADea7PB_33t1dzx-h3KIpZsdwk0",
    authDomain: "tavuel506.firebaseapp.com",
    databaseURL: "https://tavuel506.firebaseio.com",
    projectId: "tavuel506",
    storageBucket: "tavuel506.appspot.com",
    messagingSenderId: "536950237048",
    appId: "1:536950237048:web:3c9094800aa0bab8",
    vapidKey:
      "BOYLZxNFZE2AKVxp6QBfFbSIYz1bj_0PwC2ESf31H9tgd1JV5Qdy85YDJVz3b8fsHopfG1i02k6S17e_Eka9a3Y",
  },
  apiEB: "https://api.tavuel.com/eb-dev/tavuelBilling", //"http://localhost:4041/tavuelBilling", //
  p12Upload: "https://api.tavuel.com/cala-dev/html/api.php",
  placesApi: "https://api.tavuel.com/places", // "https://api.tavuel.com/places", //"http://localhost:5050",
  bucket_place: "dev/",
  billing_profile: "https://billing-profile-dev.web.app", // "https://billing-profile-dev.web.app", //"http://localhost:4041"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
